// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-campsite[data-v-00c79044]{background-color:var(--colour-red);border-radius:0 .3em .3em 0;color:#fff;display:inline-block;font-size:var(--body);font-weight:700;left:0;padding:.2em .5em;position:absolute;text-transform:uppercase;top:1.3em;z-index:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
